// Vardiya Zaman Düzenleme penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'shifts.timeEdit';

export const shiftTimeEditGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Vardiya saatleri nasıl düzeltilir?'),
  intro: t(`${G}.intro`, 'Bir personelin seçili gündeki giriş ve çıkış saatini elle düzeltir, eksik olanı tamamlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Personel bilgisi ve saat alanları'),
    footer: t(`${G}.regions.footer`, 'İptal / Zamanları Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kaydı inceleyin'),
      text: t(`${G}.s1.text`, '"Personel ve Vardiya Bilgileri" bölümünde personel adı, vardiya, kayıt tarihi ve "Mevcut Durum" (ör. Vardiya Tamamlandı, Erken Çıktı, Devam Ediyor) görünür. Saat alanlarının altında kayıtlı saat "Mevcut: …" diye yazar; kayıt yoksa "Giriş kaydı yok" / "Çıkış kaydı yok" görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Eksik saati tamamlayın'),
      text: t(`${G}.s2.text`, 'Çıkışı eksik ya da girişsiz çıkışı olan kayıtta üstte bir uyarı çıkar. Eksik olan "Giriş Zamanı" veya "Çıkış Zamanı" alanına saati girip kaydettiğinizde oturum tamamlanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Saatleri düzeltin'),
      text: t(`${G}.s3.text`, 'Saatler kayıt tarihine yazılır. Gece vardiyasında çıkış saati giriş saatinden küçükse çıkış ertesi güne sayılır. Farklı bir gün gerekiyorsa "Farklı tarih" anahtarını açıp tarihi seçin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Giriş ile çıkış arasındaki çift ok düğmesi ikisini (saat, tarih ve konum) yer değiştirir; personel yanlış yöne okuttuysa kullanın. Yalnız biri doluysa o saat diğer alana taşınır.'),
        t(`${G}.s3.tip2`, 'Bir saat alanını boşaltıp kaydederseniz o giriş ya da çıkış kaydı silinir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, '"Zamanları Kaydet" düzeltmeyi kaydeder; kayıt elle düzenlenmiş olarak işaretlenir. Başarı mesajından sonra pencere kendiliğinden kapanır. "İptal" değişiklik yapmadan kapatır.'),
    },
  ],
});
